const unformatDate = (formattedDate, format = "en-GB") => {
	if (!formattedDate || typeof formattedDate === "object") {
		return null;
	}

	const components = formattedDate.split("/");

	if ((format || "en-GB") === "en-US") {
		return new Date(+components[2], +components[0] - 1, +components[1]);
	} else {
		return new Date(+components[2], +components[1] - 1, +components[0]);
	}
};

const formatDate = (date, format = "en-GB") => {
	if (!date || typeof date !== "object" || !date.getFullYear || isNaN(date.getFullYear()) || !format) {
		return null;
	}

	let day = date.getDate();
	let month = date.getMonth() + 1;
	let year = date.getFullYear();

	if ((format || "en-GB") === "en-US") {
		return `${month < 10 ? "0" + month : "" + month}/${day < 10 ? "0" + day : "" + day}/${year}`;
	} else {
		return `${day < 10 ? "0" + day : "" + day}/${month < 10 ? "0" + month : "" + month}/${year}`;
	}
};

const formatDateTime = (date, format = "en-GB") => {
	if (!date || typeof date !== "object" || !date.getFullYear || isNaN(date.getFullYear()) || !format) {
		return null;
	}

	let dateComponent = formatDate(date, format);
	let hours = date.getHours();
	let minutes = date.getMinutes();

	let timeComponent = `${(hours < 10 ? "0" : "") + hours}:${(minutes < 10 ? "0" : "") + minutes}`;

	return `${dateComponent} ${timeComponent}`;
};

const dateDifference = (d1, d2, type = dateIntervals.Day) => {
	if (type === dateIntervals.Day || type === dateIntervals.Week) {
		var msInDay = 24 * 3600 * 1000;
		var msInWeek = msInDay * 7;
		var t2 = d2.getTime();
		var t1 = d1.getTime();

		return type === dateIntervals.Day ? Math.floor(t2 - t1) / msInDay : Math.floor(t2 - t1) / msInWeek;
	} else if (type === dateIntervals.Month) {
		var d1Y = d1.getFullYear();
		var d2Y = d2.getFullYear();
		var d1M = d1.getMonth();
		var d2M = d2.getMonth();

		return d2M + 12 * d2Y - (d1M + 12 * d1Y);
	} else {
		return d2.getFullYear() - d1.getFullYear();
	}
};

const dateIntervals = {
	Day: "day",
	Week: "week",
	Month: "month",
	Year: "year"
};

const calculateAge = (d1, d2) => {
	//calculate month difference from current date in time
	let month_diff = d2 - d1.getTime();

	//convert the calculated difference in date format
	let age_dt = new Date(month_diff);

	//extract year from date
	let year = age_dt.getUTCFullYear();

	//now calculate the age
	let age = Math.abs(year - 1970);

	//console.log("Age of the date entered: " + age + " years", d1, d2);
	return age;
};

export { dateIntervals, unformatDate, formatDate, formatDateTime, dateDifference, calculateAge };
